import { CommonModule } from '@angular/common';
import { NgModule, Optional } from '@angular/core';
import { TransitionService, UIRouterModule } from '@uirouter/angular';

import { NavigateBackDirective } from '@app/shared/modules/navigate-back/navigate-back.directive';
import { NavigateBackService } from './navigate-back.service';

@NgModule({
  imports: [CommonModule, UIRouterModule.forChild()],
  declarations: [NavigateBackDirective],
  exports: [NavigateBackDirective],
  providers: [NavigateBackService]
})
export class NavigateBackModule {
  constructor(
    // @Optional() is needed to allow styleguide to work
    @Optional() transitions: TransitionService,
    @Optional() navigateBackService: NavigateBackService
  ) {
    if (!transitions) {
      return;
    }

    transitions.onSuccess({}, transition => {
      const from = transition.$from();
      if (from.name) {
        navigateBackService.pushState({
          name: from.name,
          params: transition.params('from')
        });
      }
    });
  }
}
